//widget button logic
import { UseWidgetButton } from './WidgetButton.hooks';

//interfaces and enums
import { WidgetType } from  '@/interfaces/widgetPanel';

//styling
import '../../../../css/widgetPanel/widgetPanel.scss';



const WidgetContents = ({isNew, widgetImageUrl, widgetImageAlt, widgetTitle}:{isNew?: boolean, widgetImageUrl: string, widgetImageAlt?: string, widgetTitle: string}) => <>
    <div className='widget-image-container'>
        {isNew && <span className="is-new">NEW</span>}
        <img src={widgetImageUrl} alt={widgetImageAlt}/>
    </div>        
    <span>{widgetTitle}</span>
</>


const WidgetButton = ({onClick, type, isNew, href}: {onClick?: any, type:WidgetType, isNew?: boolean, href?:string}) => {
    const {widgetTitle, widgetImageUrl, widgetImageAlt} = UseWidgetButton(type);

    if (!widgetTitle) {
        return <></>
    }

    return !href
        ? <button className={`widget-icon ${type}-button`} onClick={onClick} name={`Add new ${widgetTitle} Widget`} type='button' tabIndex={0}>
            <WidgetContents {...{isNew, widgetImageUrl, widgetImageAlt, widgetTitle}} />
        </button>
        : <a href={href} className={`widget-icon ${type}-button`}  aria-label={`Add new ${widgetTitle} Widget`} tabIndex={0}>
            <WidgetContents {...{isNew, widgetImageUrl, widgetImageAlt, widgetTitle}} />
        </a>
}
export default WidgetButton